var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box, Center } from "@chakra-ui/react";
import { v4 } from "uuid";
import { AnalogClock } from "../../components/AnalogClock/AnalogClock";
import { DigitalClock } from "../../components/DigitalClock/DigitalClock";
const AnalogClockPreview = (_a) => {
    var { onClick, widgetWidth } = _a, rest = __rest(_a, ["onClick", "widgetWidth"]);
    const [date, setDate] = React.useState(new Date());
    const data = {
        id: v4(),
        data: {
            type: "analogic",
        },
    };
    return (React.createElement(Center, Object.assign({ onClick: () => onClick(data) }, rest),
        React.createElement(AnalogClock, { date: date, widgetWidth: widgetWidth * 0.75 })));
};
const DigitalClockPreview = (_a) => {
    var { onClick, widgetWidth } = _a, rest = __rest(_a, ["onClick", "widgetWidth"]);
    const [date, setDate] = React.useState(new Date());
    const data = {
        id: v4(),
        data: {
            type: "numeric",
        },
    };
    return (React.createElement(Box, Object.assign({ onClick: () => onClick(data) }, rest),
        React.createElement(DigitalClock, { date: date, widgetWidth: widgetWidth })));
};
export const AddPreview = [
    AnalogClockPreview,
    DigitalClockPreview,
];
